
<Modal modalType="PDFImport" mayCancel="false" v-on:done="onCancel">
  <h2>Import PDF</h2>
  <form class="PForm" v-on:click.stop novalidate>
    <p class="Form_Section">
      <label class="m-inline" for="pageStart">First page:</label>
      <input
        v-model="pageStart"
        type="number"
        min="1"
        :max="pageEnd"
        step="1"
        id="pageStart"
      />
    </p>
    <p>
      <label class="m-inline" for="pageStart">Last page:</label>
      <input
        v-model="pageEnd"
        type="number"
        :min="pageStart"
        :max="numPages"
        step="1"
        id="pageEnd"
      />
    </p>
    <p class="Form_Section">
      <label class="m-inline" for="scaleString">Scale</label>
      <input
        v-model="scaleString"
        type="number"
        min="0.01"
        :max="scaleMax"
        step="0.5"
        id="scaleString"
      />
    </p>
    <p>Page size: {{ scaledSize.x }}&times;{{ scaledSize.y }} pixels</p>
    <h3>Paging direction</h3>
    <p class="Form_Section">
      <input
        type="radio"
        id="orientation"
        name="orientation"
        value="horizontal"
        v-model="orientation"
      />&nbsp;
      <label class="m-inline" for="orientation">Horizontal &rarr;</label>
      <input
        type="radio"
        id="orientation"
        name="orientation"
        value="vertical"
        v-model="orientation"
      />&nbsp;
      <label class="m-inline" for="orientation">Vertical &darr;</label>
    </p>
  </form>
  <div class="ButtonRow-FlexSpaceBetween">
    <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
    <button class="WBMBigButton m-primary" v-on:click="confirm">
      Insert
    </button>
  </div>
</Modal>
